import { FlagIcon } from '@components/_SiteWide/Flags/FlagIcon'
import { Horizontal, Vertical } from '@gravitate-js/excalibrr'

type FlagCellRendererProps = {
  flags: Gravitate.OrderFlag[]
  hideRunout?: boolean
  hideOrderNumber?: boolean
}

export function FlagCellRenderer({ flags, hideRunout, hideOrderNumber }: FlagCellRendererProps) {
  // split flags into 3 buckets and display one each
  const runOutFlags = flags.filter((flag) => flag.type === 'run_out')
  const severe = runOutFlags?.find((flag) => flag.severity === 'error')
  const varianceFlag = flags?.find((flag) => flag.type === 'sales_variance')
  const inventoryFlags = [...(severe ? [severe] : runOutFlags), ...(varianceFlag ? [varianceFlag] : [])]

  const readingFlags = flags.filter((flag) => flag.type === 'tank_reading')
  const disconnected = readingFlags?.find((flag) => flag.name?.toLowerCase() === 'tank monitor disconnected')
  const needsManual = readingFlags?.find((flag) => flag.name?.toLowerCase() === 'disconnected needing manual')
  const readingFlag = disconnected ? [disconnected] : needsManual ? [needsManual] : readingFlags

  const complianceHold = flags.filter((flag) => flag.type === 'compliance_hold')
  const creditHold = flags?.find((flag) => flag.type === 'credit_hold')
  const holdFlag = creditHold ? [creditHold] : complianceHold

  return (
    <Horizontal verticalCenter>
      {[inventoryFlags, readingFlag, holdFlag].map((flag, key) => {
        return (
          <Vertical key={key} className='mr-2' flex={1} verticalCenter>
            {flag?.length > 0 && (
              <FlagIcon flags={flag} hideRunout={hideRunout} hideOrderNumber={hideOrderNumber} allowCarrierVisibility />
            )}
          </Vertical>
        )
      })}
    </Horizontal>
  )
}
